(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/components/orders.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/components/orders.js');
"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  useState,
  Fragment
} = React;
const {
  ButtonRow
} = svs.ticket_partner.sharedComponents.buttonRow;
const {
  Order
} = svs.ticket_partner.myOrders.components;
const {
  NO_ORDERS,
  SHOW_MORE
} = svs.ticket_partner.myOrders.constants.TEXTS;
const {
  dataFetch
} = svs.ticket_partner.services;
const ORDER_INCREMENT = 2;
const Orders = () => {
  var _data$response;
  const [ordersDisplayed, setOrdersDisplayed] = useState(ORDER_INCREMENT);
  const data = dataFetch({
    method: 'GET',
    path: '/ticket/1/triss/orders'
  });
  const sortedOrders = (data === null || data === void 0 || (_data$response = data.response) === null || _data$response === void 0 || (_data$response = _data$response.orders) === null || _data$response === void 0 ? void 0 : _data$response.sort((a, b) => new Date(b.ordered) - new Date(a.ordered))) || [];
  const showingOrdersText = "Visar ".concat(Math.min(ordersDisplayed, sortedOrders.length), " av ").concat(sortedOrders.length);
  return React.createElement(Fragment, null, sortedOrders.length === 0 && React.createElement("div", {
    className: "padding-2"
  }, NO_ORDERS), (sortedOrders === null || sortedOrders === void 0 ? void 0 : sortedOrders.length) && React.createElement(Fragment, null, sortedOrders.slice(0, ordersDisplayed).map((order, i) => React.createElement(Order, _extends({
    key: order.orderId || _.uniqueId(i)
  }, order))), React.createElement("div", {
    className: "u-text-center"
  }, React.createElement("p", null, showingOrdersText))), (sortedOrders === null || sortedOrders === void 0 ? void 0 : sortedOrders.length) > ordersDisplayed && React.createElement(ButtonRow, {
    buttons: [{
      'data-testid': 'show-more-button',
      label: SHOW_MORE,
      key: 'show-more-button',
      inverted: true,
      onClick: e => {
        e.preventDefault();
        setOrdersDisplayed(ordersDisplayed + ORDER_INCREMENT);
      }
    }],
    centerButton: true
  }));
};
svs.ticket_partner.myOrders.components.Orders = Orders;

 })(window);